import Echo from 'laravel-echo'

window.Pusher = require('pusher-js')

function getHeaders ({ app }) {
  const headers = {}

  if (app.$auth) {
    const strategy = app.$auth.strategy
    const tokenName = strategy.options.tokenName || 'Authorization'
    const token = app.$auth.getToken(strategy.name)

    if (token) {
      headers[tokenName] = token
    }
  }

  return headers
}

export default (ctx, inject) => {
  const options = {"broadcaster":"pusher","plugins":null,"authModule":true,"connectOnLogin":true,"disconnectOnLogout":true,"key":"B2BTESTKEY","cluster":"mt1","forceTLS":false,"wsHost":"websocket.anvelope.ro","authEndpoint":"https:\u002F\u002Fb2btestbackend.anvelope.ro\u002Fbroadcasting\u002Fauth","wsPort":6001,"wssPort":6001,"disableStats":true,"enabledTransports":["ws","wss"],"auth":{"headers":{"Accept":"application\u002Fjson"}}}
  options.auth = options.auth || {}
  options.auth.headers = {
    ...options.auth.headers,
    ...getHeaders(ctx)
  }

  const echo = new Echo(options)

  if (ctx.app.$auth) {
    ctx.app.$auth.$storage.watchState('loggedIn', loggedIn => {
      echo.options.auth.headers = {
        ...echo.options.auth.headers,
        ...getHeaders(ctx)
      }

      if (loggedIn) {
        echo.connect()
      }

      if (!loggedIn && echo.connector) {
        echo.disconnect()
      }
    })
  }

  ctx.$echo = echo
  inject('echo', echo)
}
